import { useContext, useState } from "react"
import { UserContext } from "../context/UserProvider"
import { Navigate } from "react-router-dom"
import { Api } from '../componentes/Api';


const VerificarUsuario = ({ children, Rol, SubRol }) => {
    const { user } = useContext(UserContext)
    const [Roles, setRoles] = useState([])

    if (user == null) {
        return <Navigate to="/Login" />
    }

    let dt = JSON.parse(user)

    const GetAsignacionModulo = async (u) => {
        let response = await fetch(Api + "Administracion/GetAsignacionModulo/" + u);
        if (response.ok) {
            let data = await response.json()
            setRoles(data)


        }
    }
    GetAsignacionModulo(dt.idUsuario)

    if (!Rol) {
        return children;
    }

    const subRolesPermitidos = `${SubRol || ""}`
        .split(",")
        .map(x => x.trim())
        .filter(x => x !== "");

    var v = Roles.filter(x => x.moduloID == Rol && (subRolesPermitidos.length === 0 || subRolesPermitidos.includes(String(x.opcionMenu)))).map(x => { return true });
    if (v.length == 0) {
        return false;
    } else { return children; }
}

export default VerificarUsuario
